'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var partnershipGridComponent = exports.partnershipGridComponent = {
    template: require('./partnership-grid.html'),
    bindings: {
        partnerships: '<',
        errorOccurred: '<',
        viewMode: '@'
    },
    controllerAs: 'vm'
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/components/partnership-grid.js
// module id = 1012
// module chunks = 0